import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import * as React from "react";
import { TSetUrlParamsArgs } from "../../../../hooks/useXoraia";
import { CheckboxFilterProps } from "../../../../utils/interfaces/core/CheckboxFilterProps";

const CheckboxFilter: React.FC<
  CheckboxFilterProps & {
    slug: string;

    onChange: (args: TSetUrlParamsArgs) => Promise<void>;

    urlParams?: TSetUrlParamsArgs;
  }
> = ({ values = [], slug, onChange, urlParams = {} }) => {
  const [list, setList] = React.useState<string[]>(urlParams[slug] ?? []);

  return (
    <FormGroup>
      {values.map((value) => (
        <FormControlLabel
          key={value}
          control={
            <Checkbox
              value={list.includes(value)}
              onChange={async (_, checked) => {
                const newList = checked
                  ? [...list, value]
                  : list.filter((i) => i !== value);

                setList(newList);

                await onChange({ [slug]: newList });
              }}
            />
          }
          label={
            <Typography
              width={"100%"}
              justifyContent="space-between"
              display="flex"
            >
              <Typography component="strong">{value}</Typography>
              {/* <Typography component="span" variant="caption">
                (10)
              </Typography> */}
            </Typography>
          }
        />
      ))}
    </FormGroup>
  );
};

export default CheckboxFilter;
